import { createClient } from '@prismicio/client';

const Client = createClient('alice-fleerackers');

export default Client;

export const linkResolver = (doc) => {
  if (doc && doc.type === 'portfolio_item') {
    return `/portfolio/${doc.uid ?? ''}`;
  }

  if (doc && doc.type === 'page') {
    return `/${doc.uid ?? ''}`;
  }

  return '/';
};
